// externals
import type { Reducer } from 'redux';

// libraries
// interfaces/types
import { TOGGLE_DEAL_MODE } from '../actionTypes/dealModeActionTypes';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { DealMode } from '../types/dealModeEnum';

export type DealModeState = {
    currentDealMode: DealMode;
};

export const modeInitialState: DealModeState = {
    currentDealMode: DealMode.deskingMode
};

export type DealModeReducer = Reducer<DealModeState>;

export const reducer: DealModeReducer = (state: DealModeState = modeInitialState, action: AnyFSA) => {
    switch (action.type) {
        case TOGGLE_DEAL_MODE: {
            return {
                ...state,
                currentDealMode: action.payload
            };
        }
        default: {
            return state;
        }
    }
};
